













import { IWorkflowState } from '@/models';

import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'WorkflowStateStatusDisplay',

  props: {
    state: {
      type: Object as PropType<IWorkflowState>,
      required: true
    }
  }
});
